export const START_INTERVIEW_REQUEST = "START_INTERVIEW_REQUEST";
export const START_INTERVIEW_RECEIVE = "START_INTERVIEW_RECEIVE";
export const HANDLE_SUBSCRIPTION = 'HANDLE_SUBSCRIPTION'
export const INTERVIEW_DURATION_REQUEST = 'INTERVIEW_DURATION_REQUEST';
export const INTERVIEW_END_MODAL = 'INTERVIEW_END_MODAL';
export const TOGGLE_INTERVIEW_END_MODAL = 'TOGGLE_INTERVIEW_END_MODAL';
export const LEAVE_INTERVIEW = 'LEAVE_INTERVIEW';